import React, { useEffect, useState } from "react";
import { Container, Row, Col, Label, Input, FormGroup } from "reactstrap";
import moment from "moment";
import {
  getAllPendingTransactions,
  searchTransactions,
  searchTransactionsByRole,
} from "../../stores/services/transactions.service";
import ReactTooltip from "react-tooltip";
import { useHistory } from "react-router-dom";
// import ViewTransaction from './../transactions/view-beta-txn';
import ViewTransaction from "./../transactions/view-payment-txn";
import { EditTransaction } from "./../../stores/services/beta-transaction.service";
import { Modal } from "react-bootstrap";
import {
  getFundByAmc,
  getInstrumentType,
} from "../../stores/services/funds.service";
import { getChecklist } from "../../stores/services/checklist.service";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CheckListItem from "../../components/checklist-item";
import {
  updateTransactionStatus,
  updateBulkTransactionStatus,
} from "../../stores/services/transactions.service";
import { BsTable } from "react-icons/bs";
import { getAmc } from "../../stores/services/amc.service";
import {
  getHBLID,
  paymentToBank,
  postHBLID,
  searchBankPaymnetTransactions,
  updateBankPaymentTransactionStatus,
} from "../../stores/services/payment-bank";
import { getAllBanks } from "../../stores/services/bank.service";
import { isDateValid } from "../../utils/customFunction";
import TrxHistory from "./trx-history";

const PaymentListing = () => {
  const history = useHistory();
  const loginUser = sessionStorage.getItem("loggedInUser") || "";
  let [bulkProcessingData, setBulkProcessingData] = useState<any>([]);
  let [transactions, setTransactions] = useState<any>([]);
  let [activePage, setActivePage] = useState("");
  let [paginationArr, setPaginationArr] = useState([""]);
  let [searchValue, setSearchValue] = useState("");
  const userEmail = sessionStorage.getItem("email") || "";
  let txnTypes = JSON.parse(sessionStorage.getItem("txnType") || "");
  let getUrlPath = (window.location.pathname.split("/").pop() || "").toString();
  const [iTypeData, setITypeData] = useState<any>([]); // Instrument Type Data hook
  const role_name = sessionStorage.getItem("role") || "";
  const [trx_history, setTrxHistory] = useState([]);
  const [viewChecklist, setViewCheckList] = useState(false);
  const [trx_checklist, setTrxCheckList] = useState([]);
  const [checklistData, setCheckListData] = useState<any>([]);
  const [reasonText, setReasonText] = useState("");
  const [reasonTextError, setReasonTextError] = useState("");
  const [rejectLoading, setRejectLoading] = useState(false);
  const [trx_id, setTrxId] = useState("");
  const [Loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [statusError, setStatusError] = useState("");
  const [changeCheck, setChangeCheck] = useState("");
  let [count, setCount] = useState(0);
  let [headLabel, setHeadLabel] = useState("");
  let [counter, setCounter] = useState("");
  let [cnt, setCnt] = useState(0);
  // const [senderBankCode, setSenderBankCode] = useState('');

  const [resLoading, setResLoading] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [clearLoading, setClearLoading] = useState(false);

  const [xReqID, setXReqID] = useState("");
  const [customerReferenceNumber, setCustomerReferenceNumber] = useState("");
  const [senderAccountID, setSenderAccountID] = useState("");
  const [restID, setRestID] = useState<any>([]);

  const [Amc, setAmc] = useState("");
  const [allAmc, setAllAmc] = useState<any>([]);
  const [allFunds, setAllFunds] = useState<any>([]);
  const [fund, setFund] = useState("");
  const [togglePagination, setTogglePagination] = useState(false);

  const [bankData, setBankData] = useState<any>([]);
  const email = sessionStorage.getItem("email") || "";

  React.useEffect(() => {
    async function getCompletedTransactions() {
      if (togglePagination != true) {
        setResLoading(true);
        await searchBankPaymnetTransactions(
          sessionStorage.getItem("email") || "",
          "",
          "",
          "",
          activePage,
        )
          .then((response) => {
            if (response.data.status === 200) {
              let pageArr = paginationArr;
              let existingPageIndex = paginationArr.findIndex(
                (x) => x === response.data.page_info.next_page_number,
              );
              if (
                existingPageIndex === -1 &&
                response.data.data.length === 10
                // &&
                // 10 * pageArr.length !== parseInt(response.data.page_info.total_count)
              ) {
                pageArr.push(response.data.page_info.next_page_number);
              }
              setPaginationArr(pageArr);
              setTransactions(response.data.data);
              setResLoading(false);
            } else if (response.data.status === 404) {
              toast.error(response.data.message);
              setTransactions([]);
              setResLoading(false);
            }
          })
          .catch((err) => {
            setResLoading(false);
          });
        setResLoading(false);
      } else {
        // if search is enable
        setResLoading(true);
        if (searchValue !== "") {
          searchValue = "TXN_" + searchValue;
        }
        await searchBankPaymnetTransactions(
          sessionStorage.getItem("email") || "",
          Amc,
          fund,
          searchValue,
          activePage,
        )
          .then((response) => {
            if (response.data.data.length > 0) {
              let pageArr = paginationArr;
              let existingPageIndex = paginationArr.findIndex(
                (x) => x === response.data.page_info.next_page_number,
              );
              if (
                existingPageIndex === -1 &&
                response.data.data.length === 10
                // &&
                // 10 * pageArr.length !== parseInt(response.data.page_info.total_count)
              ) {
                pageArr.push(response.data.page_info.next_page_number);
              }
              setPaginationArr(pageArr);
              setTransactions(response.data.data);
            } else {
              setTransactions([]);
            }
            setResLoading(false);
          })
          .catch((err) => {
            setResLoading(false);
          });
        setResLoading(false);
      }
    }
    getCompletedTransactions();
  }, [activePage]);

  // Search Transaction
  const searchTransactionsByAMCAndFund = async (
    statusVar = "",
    searchVar = "",
    amcCodeVar = "",
    fundCodeVar = "",
  ) => {
    setTogglePagination(true);
    return new Promise(async (resolve, reject) => {
      if (searchVar !== "") {
        searchVar = "TXN_" + searchVar;
      }

      setResLoading(true);
      setSearchLoading(true);
      await searchBankPaymnetTransactions(
        sessionStorage.getItem("email") || "",
        amcCodeVar,
        fundCodeVar,
        searchVar,
        activePage,
      )
        .then((response) => {
          if (response.data.data.length > 0) {
            // let pageArr = paginationArr

            paginationArr = paginationArr.filter(function (item) {
              return item == "";
            });
            let pageArr = paginationArr;
            let existingPageIndex = paginationArr.findIndex(
              (x) => x === response.data.page_info.next_page_number,
            );
            if (
              existingPageIndex === -1 &&
              response.data.data.length === 10
              // &&
              // 10 * pageArr.length !== parseInt(response.data.page_info.total_count)
            ) {
              pageArr.push(response.data.page_info.next_page_number);
            }
            setPaginationArr(pageArr);
            setTransactions(response.data.data);
          } else {
            setTransactions([]);
          }
          setResLoading(false);
          setSearchLoading(false);

          resolve("Success");
        })
        .catch((err) => {
          setResLoading(false);
          setSearchLoading(false);
          reject("Error");
        });
      setResLoading(false);
      setSearchLoading(false);
    });
  };

  React.useEffect(() => {
    const getAllChecklists = async () => {
      try {
        const response = await getChecklist(email, role_name);
        setCheckListData(response.data.data);
      } catch (err: any) {
        // toast.error(error.response.data.message[0]);
        if (err.response !== undefined) {
          toast.error(err.response.data.message);
        } else {
          toast.error("Request Failed!");
        }
      }
    };
    getAllChecklists();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const updateFormData = (obj, id) => {
    let temp = checklistData;
    temp[id] = obj;
    setCheckListData(temp);
  };

  React.useEffect(() => {
    let userInfo: any = JSON.parse(loginUser);
    let loginUserInfo: any = userInfo.amc_code.split(",");
    const getAMC = async () => {
      try {
        const amcResponse = await getAmc(email, "", "", "");
        if (loginUserInfo[0] === "" && role_name !== "CONCERNED-OFFICER") {
          setAllAmc(amcResponse.data.data);
        } else {
          const allowAmcFilter = amcResponse.data.data.filter((item) => {
            for (let i = 0; i <= loginUserInfo.length; i++) {
              if (item.amc_code === loginUserInfo[i]) {
                return item;
              }
            }
          });
          setAllAmc(allowAmcFilter);
        }
      } catch (err: any) {
        if (err.response !== undefined) {
          toast.error(err.response.data.message);
        } else {
          toast.error("Request Failed!");
        }
      }
    };
    getAMC();
  }, []);

  const renderAmcDropdown = () => {
    return allAmc.map((item: any, index: string) => {
      return (
        <option key={index} value={item.amc_code.replace("AMC_", "")}>
          {item.name}
        </option>
      );
    });
  };

  const getFunds = async (code: any) => {
    try {
      allFunds.length = 0;
      setAllFunds(allFunds);
      const response = await getFundByAmc(email, code);
      setAllFunds(response.data.data);
    } catch (error) {}
  };

  // Fund Type Drop Down
  const renderFundsDropDown = () => {
    return allFunds.map((item: any, index) => {
      return (
        <option key={index} value={item.symbol_code}>
          {item.fund_name} - {item.symbol_code}
        </option>
      );
    });
  };

  React.useEffect(() => {
    const fetchInstr = async () => {
      try {
        const inTypeResponse = await getInstrumentType(email);
        setITypeData(inTypeResponse.data.instrument_types);
      } catch (error) {}
    };
    fetchInstr();
  }, []);

  const CapTxnType = (type: any) => {
    let i, txType;
    for (i = 0; i < txnTypes.length; i++) {
      if (txnTypes[i].api_name === type) {
        txType = txnTypes[i].dis_name;
        break;
      }
    }
    return txType;
  };
  //render dropdown for iTypeData data
  const renderiTypeDataDropdown = () => {
    return iTypeData.map((item: any, index: string) => {
      return (
        <option key={index} value={item}>
          {item}
        </option>
      );
    });
  };

  const [view, setView] = useState(false);
  const [data, setData] = useState<any>([]);
  const titleCase = (value: string) => {
    let sentence = value.toLowerCase().split("_");
    for (let i = 0; i < sentence.length; i++) {
      sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
    }
    return sentence.join(" ");
  };
  const renderData = () => {
    return data.map((value: any, index: number) => {
      return (
        <>
          {value[0] !== "txn_history" && value[0] !== "file" ? (
            <Col md="6" key={index}>
              <div className="input-holder left">
                <p className="label">{titleCase(value[0])}</p>
                <div className="input-1 hide-overflow">
                  <p
                    style={{
                      fontSize: "12px",
                    }}
                  >
                    {typeof value[1] === "string"
                      ? value[0] === "file"
                        ? "N/A"
                        : value[1]
                      : value[0] === "file"
                        ? "N/A"
                        : ""}
                  </p>
                </div>
              </div>
            </Col>
          ) : (
            ""
          )}
        </>
      );
    });
  };
  const [addInstrumentModal, setAddInstrumentModal] = useState(false);
  const [updateTx, setUpdateTx] = useState<any>([]);
  const [disableIntrBtn, setDisableIntrBtn] = useState(false);
  const validate = () => {
    let statusErr = "";
    status.trim() === "" ? (statusErr = "Required") : (statusErr = "");
    if (statusErr) {
      setStatusError(statusErr);
      return false;
    } else {
      return true;
    }
  };

  const addInstrumentCall = async () => {
    updateTx.trx_id = updateTx.txn_id.replace("TXN_", "");
    updateTx.email = email;
    setDisableIntrBtn(true);
    try {
      await EditTransaction(updateTx);
      setDisableIntrBtn(false);
      setAddInstrumentModal(false);
      searchTransactionsByAMCAndFund().then(() => {
        setSearchValue("");
        setActivePage("");
      });
    } catch (error) {
      setDisableIntrBtn(false);
    }
  };
  const renderModalForInstrumentPopup = () => {
    switch (addInstrumentModal) {
      case true:
        return (
          <Modal
            className=" "
            dialogClassName="modal90w"
            show={true}
            size="lg"
            backdrop={true}
            enforceFocus={false}
            onHide={() => {
              setAddInstrumentModal(false);
            }}
          >
            <div className="modal-header justify-content-center">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => {
                  setAddInstrumentModal(false);
                  // clearTaxobject();
                }}
              >
                <i className="tim-icons icon-simple-remove" />
              </button>
              <h6 className="title title-up">Add Instrument Detail </h6>
            </div>

            <div className="modal-body">
              <div className=" ">
                <div className="form-group">
                  <div>Instrument Type</div>
                  <select
                    className={"form-control w-100 "}
                    value={updateTx["instrument_type"]}
                    onChange={(e) => {
                      setUpdateTx({
                        ...updateTx,
                        instrument_type: e.target.value,
                      });
                    }}
                  >
                    <option value="" defaultChecked hidden>
                      {" "}
                      Select Type
                    </option>
                    {renderiTypeDataDropdown()}
                  </select>
                </div>
                <div className="form-group">
                  <div>Instrument No</div>
                  <input
                    type="text"
                    defaultValue={updateTx["instrument_no"]}
                    className="form-control w-100"
                    onChange={(e) => {
                      setUpdateTx({
                        ...updateTx,
                        instrument_no: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="form-group">
                  <div>Instrument Date</div>
                  <input
                    type="date"
                    defaultValue={updateTx["instrument_date"]}
                    className="form-control w-100"
                    onChange={(e) => {
                      setUpdateTx({
                        ...updateTx,
                        instrument_date: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className=" ">
                  <button
                    className="btn btn-primary btn-block mt-3"
                    onClick={() => {
                      addInstrumentCall();
                    }}
                    disabled={Boolean(disableIntrBtn)}
                  >
                    {disableIntrBtn ? (
                      <>
                        <span
                          className="spinner-border login-txt spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        <span className="login-txt"> Loading...</span>
                      </>
                    ) : (
                      <span>Add</span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        );
      default:
        return "";
    }
  };
  const [statusSetPopup, setStatusSetPopup] = useState(false);
  const [checklistSetPopup, setCheckListSetPopup] = useState(false);
  const [bulkChecklistSetPopup, setBulkCheckListSetPopup] = useState(false);
  const renderCheckListPopup = () => {
    switch (checklistSetPopup) {
      case true:
        return (
          <Modal
            className=" "
            dialogClassName="modal90w"
            show={true}
            enforceFocus={false}
            size="xl"
          >
            <div className="modal-header">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => {
                  setCheckListSetPopup(false);
                }}
              >
                <i className="tim-icons icon-simple-remove" />
              </button>
              <h6 className="title title-up">Approval Check List </h6>
            </div>
            <div className="modal-body">
              <div className=" ">
                <div className={"checlist-scroll"}>
                  {checklistData.map((val: any, ind: any) => {
                    return (
                      <CheckListItem
                        updateFormData={updateFormData}
                        val={val}
                        ind={ind}
                      />
                    );
                  })}
                </div>
                <Row className="pt-2">
                  <Col md="12" className="d-flex mb-2">
                    <FormGroup check className="mr-3">
                      <Label check>
                        <Input
                          checked={status === "accept"}
                          type="checkbox"
                          value="accept"
                          onChange={(e) => {
                            setReasonText("");
                            setStatusError("");
                            setStatus(e.target.value);
                          }}
                        />
                        <span className="form-check-sign" />
                        Accept
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
                {/* <Row>
                  <Col md="12">
                    {statusError ? (
                      <text className="error-lab">{statusError}</text>
                    ) : (
                      ''
                    )}
                  </Col>
                </Row>
                {status !== 'accept' && (
                  <Row>
                    <Col md="12">
                      <div className="form-group">
                        <textarea
                          placeholder="Reason"
                          className={
                            'form-control w-100'
                          }
                          value={reasonText}
                          onChange={(e) => {
                            setReasonText(e.target.value);
                            setReasonTextError('');
                          }}
                        ></textarea>
                      </div>
                      {reasonTextError && (
                        <text className="error-lab">{reasonTextError}</text>
                      )}
                    </Col>
                  </Row>
                )} */}
                {/* <Row>
                  <div className="col-md-12 mt-3">
                    <button
                      className="btn btn-primary mr-3"
                      disabled={Boolean(Loading)}
                      onClick={() => {
                        updateTxStatus();
                      }}
                    >
                      {Loading ? (
                        <>
                          <span
                            className="spinner-border login-txt spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          <span className="login-txt"> Loading...</span>
                        </>
                      ) : (
                        'Submit'
                      )}
                    </button>

                    <button
                      className="btn btn-default"
                      onClick={() => {
                        setCheckListSetPopup(false);
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </Row> */}
              </div>
            </div>
          </Modal>
        );
      default:
        return "";
    }
  };

  const renderBulkCheckListPopup = () => {
    switch (bulkChecklistSetPopup) {
      case true:
        return (
          <Modal
            className=""
            dialogClassName="modal90w"
            show={true}
            enforceFocus={false}
            size="lg"
          >
            <div className="modal-header ">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => {
                  setBulkCheckListSetPopup(false);
                }}
              >
                <i className="tim-icons icon-simple-remove" />
              </button>
              <h6 className="title title-up"> Approval Check List </h6>
            </div>

            <div className="modal-body">
              <div>
                <div className={"checlist-scroll"}>
                  {checklistData.map((val: any, ind: any) => {
                    return (
                      <CheckListItem
                        updateFormData={updateFormData}
                        val={val}
                        ind={ind}
                      />
                    );
                  })}
                </div>
                <div>
                  {" "}
                  Transactions Selected:{" "}
                  <span className="text-primary">{count}</span>{" "}
                </div>
                <Row className="pb-3">
                  <Col md="12">
                    <div className="d-flex">
                      <FormGroup check className="mr-4">
                        <Label check>
                          <Input
                            checked={status === "accept"}
                            type="checkbox"
                            value="accept"
                            onChange={(e) => {
                              setReasonText("");
                              setStatusError("");
                              setStatus(e.target.value);
                            }}
                          />
                          <span className="form-check-sign" />
                          Accept
                        </Label>
                      </FormGroup>

                      <FormGroup check className="ml-1">
                        <Label check>
                          <Input
                            type="checkbox"
                            checked={status === "reject"}
                            value="reject"
                            onChange={(e) => {
                              setStatusError("");
                              setStatus(e.target.value);
                            }}
                          />
                          <span className="form-check-sign" />
                          Reject
                        </Label>
                      </FormGroup>
                    </div>
                  </Col>
                </Row>
                <Row>
                  {statusError ? (
                    <text className="error-lab">{statusError}</text>
                  ) : (
                    ""
                  )}
                </Row>
                {status === "reject" && (
                  <Row>
                    <Col>
                      <div className="form-group">
                        <textarea
                          placeholder="Reason"
                          className={"form-control w-100"}
                          value={reasonText}
                          onChange={(e) => {
                            setReasonText(e.target.value);
                            setReasonTextError("");
                          }}
                        ></textarea>
                      </div>
                      {reasonTextError && (
                        <text className="error-lab">{reasonTextError}</text>
                      )}
                    </Col>
                  </Row>
                )}
              </div>
            </div>
          </Modal>
        );
      default:
        return "";
    }
  };
  const numberWithCommas = (amount: any) => {
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />
              {!view ? (
                <div className="card">
                  <div className="card-header">
                    {/* <h4 className="card-title">AMC Transaction Listing</h4>	 */}
                    <h4 className="card-title">Online Payment</h4>
                  </div>
                  <div className="card-body">
                    <Row>
                      <Col md="2">
                        <div className="form-group">
                          <ReactTooltip
                            textColor="white"
                            backgroundColor="black"
                            effect="float"
                          />
                          <label>Transaction ID</label>
                          <input
                            type="search"
                            id="myInput"
                            placeholder="Transaction ID"
                            data-tip="Search Transaction"
                            className="form-control mr-2"
                            value={searchValue}
                            onChange={(e) => {
                              setSearchValue(e.target.value);
                            }}
                          />
                        </div>
                      </Col>

                      <Col md="2">
                        <div className="form-group ml-2 mr-2">
                          <label>Select AMC</label>
                          <select
                            className={"form-control"}
                            value={Amc}
                            onChange={(e) => {
                              setAmc(e.target.value);
                              getFunds(e.target.value);
                            }}
                          >
                            <option value="" defaultChecked hidden>
                              Select AMC
                            </option>
                            {renderAmcDropdown()}
                          </select>
                        </div>
                      </Col>

                      <Col md="2">
                        <div className="form-group ml-2 mr-2">
                          <label>Select Fund</label>
                          <select
                            className={"form-control"}
                            value={fund}
                            onChange={(e) => {
                              setFund(e.target.value);
                            }}
                          >
                            <option value="" defaultChecked hidden>
                              Select Fund
                            </option>
                            {renderFundsDropDown()}
                          </select>
                        </div>
                      </Col>

                      <Col md="4">
                        <div className=" inline-box">
                          <button
                            className="btn btn-primary mt-4"
                            disabled={Boolean(searchLoading)}
                            onClick={() => {
                              if ((searchValue || Amc || fund) !== "") {
                                setChangeCheck(searchValue);
                                setBulkProcessingData(bulkProcessingData);
                                searchTransactionsByAMCAndFund(
                                  status,
                                  searchValue,
                                  Amc,
                                  fund,
                                ).then(() => {
                                  // setPaginationArr(['']);
                                  setActivePage("");
                                });
                              }
                            }}
                          >
                            {searchLoading ? (
                              <>
                                <span
                                  className="spinner-border login-txt spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span className="login-txt"> Searching...</span>
                              </>
                            ) : (
                              "Search"
                            )}
                            {/* Search		 */}
                          </button>
                          <button
                            className="btn btn-default mt-4"
                            disabled={Boolean(clearLoading)}
                            onClick={() => {
                              setCount(0);
                              setAmc("");
                              setFund("");
                              setChangeCheck("");
                              setSearchValue("");
                              setBulkProcessingData([]);
                              searchTransactionsByAMCAndFund().then(() => {
                                setSearchValue("");
                                setActivePage("");
                              });
                            }}
                          >
                            {clearLoading ? (
                              <>
                                <span
                                  className="spinner-border login-txt spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span className="login-txt"> Clear</span>
                              </>
                            ) : (
                              "Clear"
                            )}
                          </button>
                        </div>
                      </Col>

                      {/* <Col md="4">
                        <div className="form-group">
                          <ReactTooltip
                            textColor="white"
                            backgroundColor="black"
                            effect="float"
                          />
                          <label>Transaction ID</label>
                          <input
                            type="search"
                            id="myInput"
                            placeholder="Transaction ID"
                            data-tip="Search Transaction"
                            className="form-control mr-2"
                            value={searchValue}
                            onChange={(e) => {
                              setSearchValue(e.target.value);
                            }}
                          />
                        </div>
                      </Col>

                      <Col md="6">
                        <div className="inline-box">
                          <button
                            className="btn btn-primary mt-4"
                            disabled={Boolean(searchLoading)}
                            onClick={() => {
                              searchFilters(searchValue).then(() => {
                                setActivePage('');
                              });
                            }}
                          >
                            {searchLoading ? (
                              <>
                                <span
                                  className="spinner-border login-txt spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span className="login-txt"> Searching...</span>
                              </>
                            ) : (
                              'Search'
                            )}
                          </button>
                          <button
                            className="btn btn-default mt-4"
                            disabled={Boolean(clearLoading)}
                            onClick={() => {
                              clearFilters('').then(() => {
                                setActivePage('');
                                setSearchValue('');
                              });
                            }}
                          >
                            {clearLoading ? (
                              <>
                                <span
                                  className="spinner-border login-txt spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span className="login-txt"> Clear</span>
                              </>
                            ) : (
                              'Clear'
                            )}
                          </button>
                        </div>
                      </Col> */}
                    </Row>
                    <div className="">
                      {resLoading ? (
                        <div className="d-flex justify-content-center my-5">
                          <i
                            className="fa fa-spinner fa-spin fa-3x"
                            aria-hidden="true"
                          ></i>
                        </div>
                      ) : transactions.length > 0 ? (
                        <div className="table-responsive">
                          <table className="table mt-3">
                            <thead>
                              <tr>
                                {/* <th><FormGroup check>
                                    <Label check>
                                      <Input type="checkbox"
                                        checked={checkAllBoolean(transactions)}
                                        onChange={(e) => {
                                          if (e.target.checked === true) {
                                            addAllTxnForBulk(transactions);
                                          } else {
                                            removeAllTxnFromBulk(transactions);
                                          }
                                        }} />
                                      <span className="form-check-sign" />
                                    </Label>
                                  </FormGroup></th> */}
                                <th>Date</th>
                                <th>Transaction</th>
                                <th>Fund</th>
                                <th>Bank</th>
                                <th className="text-right">Amount</th>
                                <th>Type</th>
                                <th>Instrument</th>
                                <th>Counter</th>
                                <th>Created</th>
                                <th>Status</th>
                                <th>Act</th>
                              </tr>
                            </thead>
                            <tbody>
                              {transactions.map((transaction: any, index) => {
                                return (
                                  <tr key={index}>
                                    {/* <td>
                                        <FormGroup check>
                                          <Label check>
                                            <Input type="checkbox"
                                              checked={checkBoolean(transaction.txn_id.replace('TXN_', ''))}
                                              onChange={(e) => {
                                                if (e.target.checked === true) {
                                                  addTxnForBulk(transaction);
                                                } else {
                                                  removeTxnFromBulk(transaction);
                                                }
                                              }} />
                                            <span className="form-check-sign" />
                                          </Label>
                                        </FormGroup>
                                      </td> */}
                                    <td>
                                      {isDateValid(
                                        moment(
                                          transaction.instruction_date,
                                        ).format("DD-MMM"),
                                      )}{" "}
                                      <br />
                                      <span className="sub-content">
                                        Exe:{" "}
                                        {moment(
                                          transaction.execution_date,
                                        ).format("DD-MMM")}
                                      </span>
                                    </td>

                                    <td>
                                      {transaction.txnr_type ? (
                                        <span
                                          style={{
                                            display: "inline-block",
                                            width: "100px",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                          }}
                                        >
                                          {CapTxnType(transaction.txnr_type)}
                                        </span>
                                      ) : (
                                        "N/A"
                                      )}
                                      <br />{" "}
                                      <span className="sub-content">
                                        {transaction.txn_id.replace("TXN_", "")}
                                      </span>
                                    </td>

                                    <td>
                                      {transaction.fund_code} <br />
                                      <span className="sub-content">
                                        {transaction.amc_code
                                          ? transaction.amc_code
                                          : "N/A"}{" "}
                                      </span>
                                    </td>

                                    <td>
                                      {transaction.bank}
                                      <br />
                                      <span className="sub-content">
                                        {transaction.account_number.length > 6
                                          ? "..." +
                                            transaction.account_number.substring(
                                              transaction.account_number
                                                .length - 6,
                                            )
                                          : transaction.account_number}
                                      </span>
                                    </td>

                                    <td className="text-right pr-3">
                                      {numberWithCommas(
                                        parseInt(transaction.net_amount || ""),
                                      )}{" "}
                                      <br />
                                      <span className="sub-content">
                                        {numberWithCommas(
                                          parseInt(
                                            transaction.gross_amount || "",
                                          ),
                                        )}
                                      </span>
                                    </td>
                                    <td>
                                      {transaction?.mode_of_payment}
                                      <br />
                                      <span className="sub-content">
                                        {transaction?.payment_type}
                                      </span>
                                    </td>

                                    <td>
                                      {transaction.instrument_type}
                                      <br />
                                      <span className="sub-content">{`${transaction?.instrument_no === "" ? isDateValid(moment(transaction?.instrument_date).format("DD-MMM-YY")) : transaction?.instrument_no}`}</span>
                                    </td>

                                    <td>
                                      {transaction.counter_bank} <br />
                                      <span className="sub-content">
                                        {transaction.counter_account_number
                                          .length > 6
                                          ? "..." +
                                            transaction.counter_account_number.substring(
                                              transaction.counter_account_number
                                                .length - 6,
                                            )
                                          : transaction.counter_account_number}
                                      </span>
                                    </td>

                                    <td>
                                      {moment(transaction.created_at).format(
                                        "DD-MM-YYYY",
                                      )}{" "}
                                      <br />
                                      {/* <span className="sub-content">{transaction.created_by	
                                ? transaction.created_by	
                                : 'N/A'}</span>	 */}
                                      <span className="sub-content">
                                        {transaction.created_by.split("@")[0]}
                                      </span>
                                    </td>
                                    <td>
                                      {transaction.txn_status}
                                      <br />
                                      <span className="sub-content">
                                        {transaction.txn_status ===
                                        "COMPLETED" ? (
                                          <>{`Realized (${isDateValid(moment(transaction?.txn_history[transaction?.txn_history?.length - 1]?.updated_at).format("DD-MMM-YY"))})`}</>
                                        ) : (
                                          <>Unrealized</>
                                        )}
                                      </span>
                                    </td>
                                    <td>
                                      <div className="multi-icons pointer">
                                        <button
                                          type="button"
                                          className="btn-icon text-center btn-link like btn btn-primary btn-sm"
                                          onClick={() => {
                                            // let objArr = Object.entries(transaction);
                                            // setData(objArr);
                                            // setView(true);
                                            setView(true);
                                            setTrxId(
                                              transaction.txn_id.replace(
                                                "TXN_",
                                                "",
                                              ),
                                            );
                                            setCounter(transaction.counter);
                                            setData(transaction);
                                            setTrxHistory(
                                              transaction.txn_history,
                                            );
                                          }}
                                        >
                                          <i className="fa fa-eye"> </i>
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <div className="table-empty">
                          <BsTable className="icon" />
                          <p className="text-center empty-text">
                            No record found
                          </p>
                        </div>
                      )}
                      <div
                        className="row pointer pr-3"
                        style={{
                          float: "right",
                        }}
                      >
                        {/* PREVIOUS BUTTON */}
                        {activePage !== paginationArr[0] ? (
                          <i
                            className="fa fa-arrow-left"
                            aria-hidden="true"
                            onClick={() => {
                              let pageArr = paginationArr;
                              let index = pageArr.findIndex(
                                (x) => x === activePage,
                              );
                              if (index !== -1) {
                                setActivePage(paginationArr[index - 1]);
                              }
                            }}
                          ></i>
                        ) : (
                          ""
                        )}
                        {/* NEXT BUTTON */}
                        {activePage !==
                        paginationArr[paginationArr.length - 1] ? (
                          <i
                            className="fa ml-3 fa-arrow-right"
                            aria-hidden="true"
                            onClick={() => {
                              let pageArr = paginationArr;
                              let index = pageArr.findIndex(
                                (x) => x === activePage,
                              );
                              if (index !== -1) {
                                setActivePage(paginationArr[index + 1]);
                              }
                            }}
                          ></i>
                        ) : (
                          ""
                        )}
                      </div>

                      {count === 0 ? (
                        ""
                      ) : (
                        <div className="mb-2">
                          <span className="text-primary">{count}</span>{" "}
                          transactions selected. &nbsp;{" "}
                          <a
                            onClick={() => {
                              bulkProcessingData.length = 0;
                              setBulkProcessingData(bulkProcessingData);
                              setCount(0);
                              setChangeCheck(`${count}`);
                            }}
                          >
                            Clear Selection{" "}
                          </a>{" "}
                        </div>
                      )}

                      {bulkProcessingData.length > 0 && (
                        <Row>
                          <Col md="6">
                            <div className="d-flex">
                              <div className="">
                                <button
                                  className="btn btn-primary"
                                  disabled={Boolean(Loading)}
                                  onClick={() => {
                                    setBulkCheckListSetPopup(true);
                                  }}
                                >
                                  Action
                                </button>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div className=" ">
                  <h4>
                    <i
                      className="fa fa-angle-left mr-2 mt-1 pointer"
                      onClick={() => {
                        setView(false);
                      }}
                    ></i>
                    View - Transaction
                  </h4>
                  <ViewTransaction data={data} />
                  {/* <div className=" ">
                    <button
                      className="btn btn-primary mr-4 bg-positive"
                      disabled={Boolean(Loading)}
                      onClick={() => {
                        setCheckListSetPopup(true);
                      }}
                    >
                      <span>Action</span>
                    </button>
                  </div> */}
                  <div className="line"></div>
                  <TrxHistory
                    trx_history={trx_history}
                    onClick={(hist) => {
                      if (hist.action === "CREATED") {
                        return;
                      }
                      if (!hist.check_list) return;
                      setTrxCheckList(hist.check_list);
                      setViewCheckList(true);
                    }}
                  />
                </div>
              )}
              {renderBulkCheckListPopup()}
              {renderCheckListPopup()}
              {renderModalForInstrumentPopup()}
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default PaymentListing;
